import React from "react";
import Menu from "../Menu";
import CommonSendComponent from "../../components/CommonSendComponent";
import { getSendConfig } from "../../Configs/SendConfigs";

const SendaudioPackage = () => {
  const config = getSendConfig('audioPackage');

  return (
    <>
      <Menu />
      <CommonSendComponent config={config} />
    </>
  );
};

export default SendaudioPackage;
